import React from 'react';
import { space } from 'styled-system';
import { styled } from '@teko/ui';
import { getTrackingData } from '@teko/tracking';
import { Text } from '../Text/Text.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = styled.div(`
  display: flex;
  padding: 12px 16px;
  align-items: center;
  background: #ffffff;
`, space);
const Left = styled.div`
  margin-right: 12px;
`;
const Right = styled.div`
  margin-left: 12px;
`;
const Content = styled.div`
  flex: 1;
  overflow: hidden;
`;
const SubTitle = styled.div`
  font-size: 13px;
  color: #82869e;
`;
const ListItem = (_a) => {
  var _b = _a, {
    left,
    title,
    subTitle,
    right,
    regionName,
    contentName,
    target,
    onClick,
    payload
  } = _b, props = __objRest(_b, [
    "left",
    "title",
    "subTitle",
    "right",
    "regionName",
    "contentName",
    "target",
    "onClick",
    "payload"
  ]);
  return /* @__PURE__ */ React.createElement(Wrapper, __spreadValues(__spreadProps(__spreadValues({}, props), {
    onClick: () => {
      if (onClick)
        onClick();
    }
  }), getTrackingData({
    isTrackContent: true,
    regionName,
    contentName,
    target,
    payload
  })), left && /* @__PURE__ */ React.createElement(Left, null, left), /* @__PURE__ */ React.createElement(Content, null, typeof title === "string" ? /* @__PURE__ */ React.createElement(Text, {
    fontWeight: "500"
  }, title) : title, subTitle && /* @__PURE__ */ React.createElement(SubTitle, null, subTitle)), right && /* @__PURE__ */ React.createElement(Right, null, right));
};

export { ListItem };
